// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setup {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
    padding: 20px;
    font-family: "Montserrat", sans-serif;
    background-color: #f5f5f5;
}

.Setup_container {
    border: 1px solid #ddd;
    border-radius: 12px; /* Increase border radius for a softer look */
    overflow-y: auto;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add subtle box shadow */
}

.Setup_right_col2 {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 900px; /* Increase maximum width for better content presentation */
    margin: 0 auto;
}

/* Button Styles */


/* Form Input Fields */
.Projects_fieldEntry {
    width: 100%;
    padding: 14px;
    border: 1px solid #ccc;
    border-radius: 8px;
    margin-bottom: 20px;
    transition: border-color 0.3s ease;
}

.Projects_fieldEntry:focus {
    border-color: #4caf50;
}

/* General Styling */
.red-star {
    color: red;
}

.Projects_fieldsRow {
    margin-bottom: 30px; /* Increase margin between rows */
}

.Projects_fieldLabel {
    font-weight: bold;
    margin-bottom: 12px;
}

.Phases_selectedDocument {
    cursor: pointer;
    padding: 14px;
    border: 1px solid #ccc;
    border-radius: 8px;
    display: flex;
    align-items: center;
    transition: background-color 0.3s ease;
}

.Phases_selectedDocument:hover {
    background-color: #f0f0f0;
}

.Phases_selectedDocumentDropdown {
    margin-left: auto;
    transform: rotate(0deg);
    transition: transform 0.3s ease;
}

.Phases_selectedDocument:hover .Phases_selectedDocumentDropdown {
    transform: rotate(180deg);
}

.Projects_authorizedPhasesWrapper {
margin-bottom: 20px;
}

.Projects_authorizedPhases {
display: flex;
justify-content: space-between;
}

.Projects_authorizedPhase {
display: flex;
align-items: center;
gap: 5px;
padding: 10px;
background: #e4e4e4;
border-radius: 6px;
}

.Projects_authorizedPhaseLabel {
font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Setup/Setup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB,EAAE,6CAA6C;IAClE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,wCAAwC,EAAE,0BAA0B;AACxE;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB,EAAE,2DAA2D;IAC7E,cAAc;AAClB;;AAEA,kBAAkB;;;AAGlB,sBAAsB;AACtB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB,EAAE,iCAAiC;AAC1D;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,aAAa;AACb,8BAA8B;AAC9B;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,QAAQ;AACR,aAAa;AACb,mBAAmB;AACnB,kBAAkB;AAClB;;AAEA;AACA,eAAe;AACf","sourcesContent":[".Setup {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow: hidden;\n    padding: 20px;\n    font-family: \"Montserrat\", sans-serif;\n    background-color: #f5f5f5;\n}\n\n.Setup_container {\n    border: 1px solid #ddd;\n    border-radius: 12px; /* Increase border radius for a softer look */\n    overflow-y: auto;\n    padding: 20px;\n    background-color: #fff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add subtle box shadow */\n}\n\n.Setup_right_col2 {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 900px; /* Increase maximum width for better content presentation */\n    margin: 0 auto;\n}\n\n/* Button Styles */\n\n\n/* Form Input Fields */\n.Projects_fieldEntry {\n    width: 100%;\n    padding: 14px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    transition: border-color 0.3s ease;\n}\n\n.Projects_fieldEntry:focus {\n    border-color: #4caf50;\n}\n\n/* General Styling */\n.red-star {\n    color: red;\n}\n\n.Projects_fieldsRow {\n    margin-bottom: 30px; /* Increase margin between rows */\n}\n\n.Projects_fieldLabel {\n    font-weight: bold;\n    margin-bottom: 12px;\n}\n\n.Phases_selectedDocument {\n    cursor: pointer;\n    padding: 14px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    transition: background-color 0.3s ease;\n}\n\n.Phases_selectedDocument:hover {\n    background-color: #f0f0f0;\n}\n\n.Phases_selectedDocumentDropdown {\n    margin-left: auto;\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n}\n\n.Phases_selectedDocument:hover .Phases_selectedDocumentDropdown {\n    transform: rotate(180deg);\n}\n\n.Projects_authorizedPhasesWrapper {\nmargin-bottom: 20px;\n}\n\n.Projects_authorizedPhases {\ndisplay: flex;\njustify-content: space-between;\n}\n\n.Projects_authorizedPhase {\ndisplay: flex;\nalign-items: center;\ngap: 5px;\npadding: 10px;\nbackground: #e4e4e4;\nborder-radius: 6px;\n}\n\n.Projects_authorizedPhaseLabel {\nfont-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
